<template>
  <span
    class="calendar-sorting d-flex flex-wrap align-items-center justify-content-between justify-content-md-start position-relative"
  >
    <h2
      class="calendar-sorting__title order-sm-1"
      :class="{ 'w-100': $mq === 'sm' && selectedView === 'week' }"
    >
      {{ $t('calendar.title') }}
    </h2>
    <DateSwitch
      @changeDateStart="$emit('changeDateStart', $event)"
      @toMonthView="selectView('month')"
      :selectedView="view"
      :startDay="startDay"
      :endDay="endDay"
      class="order-sm-3 order-lg-2"
    />
    <HorizontalSelector
      @select="selectView($event)"
      :options="calendarModes"
      :active="view"
      class="d-none d-sm-inline-block mb-0 order-sm-2 order-lg-3 pb-4 pb-lg-0"
    />
    <Search @search="$emit('search', $event)" class="order-sm-4" />
    <!-- TODO: add fade -->
    <span
      @mousedown="scrollStart = $event.clientX"
      @mousemove="dragToScroll($event)"
      @mouseover="scrollStart = false"
      @mouseup="scrollStart = false"
      id="eventFilters"
      class="eventFilters order-sm-5"
    >
      <filter-button
        v-for="(category, index) of categotiesOfEventsList"
        :key="index"
        @click.native="activateEventFilter(category)"
        :active="category.active"
        :text="$t(`calendar.header.events.${category.type}`)"
        :color="category.color"
      />
    </span>
  </span>
</template>

<script>
import DateSwitch from './DateSwitch'
import HorizontalSelector from '@/components/Screener/HorizontalSelector'
import Search from './Search'
import FilterButton from './FilterButton'

export default {
  props: {
    selectedView: String,
    startDay: Date,
    endDay: Date,
  },
  data() {
    return {
      list: ['Инструменты', 'Все события'],
      stockExchangeList: [
        { name: 'Московская биржа', value: 'MOEX', checkboxIsOpen: true },
        { name: 'Лондонская биржа', value: 'LSE', checkboxIsOpen: true },
      ],
      additionalSettings: [
        { name: 'Только "Избранные"', checkboxIsOpen: false },
      ],
      categotiesOfEventsList: [
        {
          type: 'event',
          active: false,
          color: '#AF52DE',
        },
        {
          type: 'div',
          active: false,
          color: '#007AFF',
        },
      ],
      scrollStart: false,
    }
  },
  computed: {
    calendarModes() {
      return [
        { name: this.$t('calendar.header.mode.week'), value: 'week' },
        { name: this.$t('calendar.header.mode.month'), value: 'month' },
      ]
    },
    view() {
      return this.selectedView
    },
  },
  methods: {
    selectView: function(value) {
      this.$emit('selectView', value)
    },
    dragToScroll(ev) {
      if (this.scrollStart) {
        const elem = document.getElementById('eventFilters')
        elem.scrollLeft = this.scrollStart - ev.clientX
      }
    },
    activateEventFilter(category) {
      category.active = !category.active
      this.$emit('selectEventCategory', {
        type: category.type,
        active: category.active,
      })
    },
  },
  components: {
    DateSwitch,
    HorizontalSelector,
    Search,
    'filter-button': FilterButton,
  },
}
</script>

<style lang="scss">
.calendar-sorting {
  & > * {
    margin-right: 26px;
  }
  & > :last-child {
    margin-right: 0;
  }

  &__title {
    width: 100%;
    letter-spacing: -0.06666rem;
    word-spacing: -0.06666rem;
    margin-bottom: 26px;
  }

  &__selectors {
    display: inline;
    width: 20rem;
  }

  .eventFilters {
    display: flex;
    overflow-x: scroll;
    width: 24%;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  @media (max-width: 576px) {
    display: none;

    &__title {
      width: 55%;
      margin-right: 0 !important;
      display: inline-block;
      margin-top: 8px;
      margin-bottom: 11px;
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 0.1px;
    }

    &__mobile-buttons {
      display: inline-block;
      position: absolute;
      top: 6px;
      right: 16px;
    }
    &__button {
      border-color: #c2c2d6 !important;
      color: $title-color !important;

      margin-right: 0;
      margin-left: 8px;
      &:first-child {
        padding: 1px 3px 3px 3px;
      }
      &:last-child {
        padding: 1px 9px;
      }
      &-text {
        margin-bottom: 0;
        font-size: 12px;
        padding-bottom: 2px;
      }
    }
    &__date-month {
      &_text {
        color: $title-color;
        font-size: 12px;
        font-weight: bold;
        position: relative;
        margin-top: 10px;
        margin-bottom: 5px;
        &.right {
          width: calc(100% - 30px);
          padding-bottom: 6px;
          position: absolute;
          top: 36px;
          right: 16px;
          border-bottom: #c2c2d6 0.06666rem solid;
          text-align: right;

          & > * {
            display: inline-block;
          }
          & > p {
            margin-bottom: 2px;
            width: 22%;
            text-align: center;
          }
          & > svg {
            margin-top: 2px;
          }
        }
      }
    }
    .eventFilters {
      width: 100%;
    }
  }

  @media (min-width: 576px) {
    &-mobile {
      display: none;
    }
  }

  @media (min-width: 576px) and (max-width: 767px) {
    &__title {
      width: 65%;
      margin-right: 20px;
    }
    .eventFilters {
      width: 100%;
    }
  }
  @media (min-width: 767px) and (max-width: 992px) {
    &__title {
      width: 50%;
    }
    .eventFilters {
      width: 100%;
      margin-top: 25px;
    }
  }

  @media (max-width: 767px) {
    & > * {
      margin-right: 20px;
    }
    .horizontal-selector {
      margin-right: 0;
    }
    .eventFilters {
      margin-top: 25px;
    }
  }
}
</style>
